'use client';

import React, { useContext } from 'react';
import { StyledSupportivePanelContainer } from './elements';
import { TemplateContext } from '../TemplateContext';
export const SupportivePanelContainer = ({
  children
}) => {
  const context = useContext(TemplateContext);
  return /*#__PURE__*/React.createElement(StyledSupportivePanelContainer, {
    hasImage: context.hasImage
  }, children);
};